<template>
	<div class="main">
		<header class="panel-heading">
			<h3 class="panel-title">設定打掃點</h3>
		</header>
		<section class="panel panel-default" style="margin-bottom: 0px;">
			<header class="panel-heading" style="padding: 10px;">
				<div class="panel-actions" style="top: 7px;">
					<a id="openSearch" href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
				</div>
				<h4 class="panel-title">查詢條件</h4>
			</header>
			<div id="searchArea" class="panel-collapse collapse">
				<div class="panel-body">
					<div class="row form-group">
						<div class="col-md-6">
							<label class="col-md-4">房棟</label>
							<div class="col-md-8">
								<select v-model="qryParam.house" @change="changeQryHouse()">
									<option value="">--請選擇--</option>
									<option v-for="(item, key) in houseList" :key="key" :value="item.val" >{{item.val}}</option>
								</select>
							</div>
						</div>
						<div class="col-md-6">
							<label class="col-md-4">樓層</label>
							<div class="col-md-8">
								<select v-model="qryParam.flood" >
									<option value="">--請選擇--</option>
									<option v-for="(item, key) in floodList" :key="key" :value="item.val" >{{item.val}}</option>
								</select>
							</div>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-offset-4 col-md-4 ">
							<div class="col-md-offset-4 col-md-4">
								<button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<div class="tab-content" style="min-height:350px;">
			<div class="tab-pane fade in show" role="tabpanel" aria-labelledby="vacation-tab">
				<div class="row form-group">
					<div class="col-md-12 text-right form-inline">
						<div class="col-md-8">
							<label class="col-md-3">設定開放時間: </label>
							<div class="col-md-8 form-inline">
								<datepicker :format="customFormatter" :language="zh" v-validate="'required'" v-model="beginSetting" id="beginDate" input-class="date-input form-control" placeholder="開始日期" :style="{width:'35%', display:'inline-block'}" :disabled-dates="{to:new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())}"/>
								~
								<datepicker :format="customFormatter" :language="zh" v-validate="'required'" v-model="endSetting" id="endDate" input-class="date-input form-control" placeholder="結束日期" :style="{width:'35%', display:'inline-block'}" :disabled-dates="{to:new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())}"/>
								<button type="button" @click="settingOpenTime">送出</button>
							</div>
						</div>
						<div class="col-md-4 text-right">
							<label for="fileV" class="btn btn-primary hidden-xs">資料匯入</label>
							<label for="fileV" class="btn btn-primary btn-block visible-xs">資料匯入</label>
							<input id="fileV" ref="fileV" name="file" type="file" value accept=".xls, .xlsx" style="display: none" @change="fileUpload($event)" />
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-12">
						<a href="javascript:;" class="btn btn-link" @click="downloadSample">打掃點檔案(上傳範例)</a>
						<table class="table table-no-more table-bordered table-striped mb-none" >
							<thead>
								<tr>
									<th class="text-center" width="10%">刪除</th>
									<th class="text-center" width="30%">房棟</th>
									<th class="text-center" width="30%">樓層</th>
									<th class="text-center" width="30%">打掃名稱</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in cleanUpList" :key="index">
									<td data-title="刪除" class="text-center">
										<button type="button" class="mb-xs mt-xs mr-xs btn-xs btn-primary" @click="deleteCleanUp(item)"><i class="fa fa-minus-circle"></i></button>
									</td>
									<td data-title="房棟" class="text-center">{{item.house}}</td>
									<td data-title="樓層" class="text-center">{{item.flood}}</td>
									<td data-title="打掃名稱" class="text-center">{{item.cleanLocation}}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="col-md-12">
						<div class="text-center">
							<pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data(){
		return {
			qryParam:{
				house:"",
				flood:"",
			},
			cleanUpList:[],
			houseList:[],
			floodList:[],
			respFloodList:[],
			commCode:{},
			page:1,
			totalPage:0,
			beginState:{
				disabledDates:{
					to: null
				}
			},
			endState:{
				disabledDates:{
					to: null
				}
			},
			beginSetting:null,
			endSetting:null,
		};
	},
	created(){
		const now = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
		console.log(new Date());
		this.beginState.disabledDates.to = now;
		this.endState.disabledDates.to = now;
	},
	mounted(){
		if(document.body.clientWidth < 1024){
			let di = document.querySelectorAll(".date-input");
			for(let i=0; i<di.length; i++){
				di[i].style.width = '100%';
			}
			let vdpc = document.querySelectorAll(".vdp-datepicker__calendar");
			for(let i=0; i<vdpc.length; i++){
				vdpc[i].style.width = '180px';
				vdpc[i].style.left="-40px";
			}
		}
		this.init();
		this.gridInit();
	},
	methods:{
		init(){
			const api = "/api/Environment/cleanUpInit";
			this.$axios.post(api).then(resp => {
				this.houseList = resp.data.data.houseList;
				this.respFloodList = resp.data.data.floodList;
			});
			this.$axios.post("/api/Common/commCodeList/SET_CLEAN").then(resp =>{
				let commCodeList = resp.data.data;
				if(commCodeList.length > 0){
					this.commCode = commCodeList[0];
					this.beginSetting = this.commCode.commValue;
					this.endSetting = this.commCode.commValue2
				}
			});
		},
		changeQryHouse(){
			this.floodList = this.respFloodList.filter(item => {
				return item.key == this.qryParam.house;
			});
		},
		fileUpload(e){
			// console.log(e);
			const api = "/api/Environment/impCleanUp";
			let _this = this;
			let excelFile = e.target.files[0];
			let formData = new FormData();
			formData.append("xlsx", excelFile);
			this.$axios.post(api, formData).then(resp => {
				if (resp.data.status === "success") {
					bootbox.alert(resp.data.msg.replace(new RegExp("\r?\n", "g"), "<br />" ));
					this.gridInit();
				} else {
					bootbox.alert(resp.data.msg.replace(new RegExp("\r?\n", "g"), "<br />"));
				}
			});
			e.target.value = "";
		},
		gridInit(){
			const api = "/api/Environment/cleanUpList";
			this.$axios.post(api, JSON.stringify({
				model:this.qryParam,
				page:this.page,
				pageSize:10
			})).then(resp => {
				this.cleanUpList = resp.data.data.rows;
				this.page = resp.data.data.page;
				this.totalPage = resp.data.data.total;
			});
		},
		updateGrid(page) {
			//更新Grid 必需
			this.page = page;
			this.gridInit();
		},
		deleteCleanUp(item){
			let _this = this;
			if(item.defStaffAccount){
				bootbox.alert("該打掃點，已設定打掃人員。");
			}else{
				const api = "/api/Environment/deleteCleanUp/"+item.id;
				bootbox.confirm("是否確認要刪除此筆資料？", (result) => {
					if(result){
						_this.$axios.delete(api).then(resp =>{
							_this.gridInit();
						});
					}
				});
			}
		},
		clickFileUpload(id){
			document.querySelector(`#${id}`).click();
		},
		downloadSample(){
			const api = `/api/Common/downloadFile/設定打掃點Template.xlsx`;
			this.$axios.post( api, null, { 
				headers: { "Content-Type": "application/json" },
				responseType: "blob" 
			}).then(resp => {
				const url = window.URL.createObjectURL(new Blob([resp.data]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "設定打掃點範例.xlsx");
				document.body.appendChild(link);
				link.click();
			});
		},
		settingOpenTime(){
			if(new Date(this.beginSetting) > new Date(this.endSetting)){
				bootbox.alert("結束時間不得小於開始時間");
			}else{
				const api = `/api/Common/modifyCommCode`;
				this.commCode.commValue = this.customFormatter(this.beginSetting);
				this.commCode.commValue2 = this.customFormatter(this.endSetting);
				this.$axios.post(api, JSON.stringify(this.commCode)).then(resp => {
					bootbox.alert(resp.data.msg);
				});
			}
		}
	},
	watch:{
		beginSetting:function(val){
			let date = new Date(val);
			if(new Date(this.endSetting) < date){
				this.endSetting = date;
			}
			this.endState.disabledDates.to = date;
		},
	}
}
</script>
<style>
</style>